<div class="flex flex-col max-h-[90vh]">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
    <div class="flex items-center gap-2">
      <mat-icon [svgIcon]="'tabler_outline:users'" class="!w-5 !h-5 text-primary-600"></mat-icon>
      <div>
        <h2 class="font-semibold text-gray-900 dark:text-white">Odbiorcy kampanii</h2>
        <p class="text-xs text-gray-500">{{ data.campaign.name }}</p>
      </div>
    </div>
    <button mat-icon-button (click)="close()" class="!w-8 !h-8">
      <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-4 !h-4"></mat-icon>
    </button>
  </div>

  <!-- Tabs -->
  <mat-tab-group class="flex-1 overflow-hidden">
    
    <!-- Tab: Filtry -->
    <mat-tab label="Filtry">
      <div class="p-4 overflow-y-auto max-h-[55vh]">
        <form [formGroup]="filterForm" class="space-y-3">
          
          <!-- Filters row -->
          <div class="grid grid-cols-3 gap-3">
            <mat-form-field appearance="outline" class="w-full compact-field">
              <mat-label>Typy subskrypcji</mat-label>
              <mat-select formControlName="subscriptionStages" multiple (selectionChange)="onFilterChange()">
                <mat-option *ngFor="let type of subscriptionStages" [value]="type.value">
                  {{ type.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full compact-field">
              <mat-label>Płatny abonament</mat-label>
              <mat-select formControlName="hasPaidSubscription" (selectionChange)="onFilterChange()">
                <mat-option [value]="null">Wszystkie</mat-option>
                <mat-option [value]="true">Tylko płatne</mat-option>
                <mat-option [value]="false">Tylko FREE</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full compact-field">
              <mat-label>Sync (dni)</mat-label>
              <input matInput formControlName="lastSyncDaysAgo" type="number" min="1" max="365" (change)="onFilterChange()">
              <mat-hint>Ostatnia sync nie później niż X dni</mat-hint>
            </mat-form-field>
          </div>

          <!-- Preview & Action -->
          <div class="flex items-center gap-3 pt-2">
            <div class="flex-1 flex items-center gap-3 px-3 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg">
              <mat-spinner *ngIf="isLoadingPreview" diameter="20"></mat-spinner>
              <span *ngIf="!isLoadingPreview" class="text-xl font-bold text-primary-600">{{ totalCount }}</span>
              <span class="text-sm text-gray-500">odbiorców</span>
            </div>
            <button mat-flat-button color="primary" [disabled]="isAssigning || totalCount === 0" (click)="assignRecipients()">
              <mat-icon *ngIf="isAssigning" class="icn-spinner" [svgIcon]="'tabler_outline:loader'"></mat-icon>
              <mat-icon *ngIf="!isAssigning" [svgIcon]="'tabler_outline:check'"></mat-icon>
              Przypisz
            </button>
          </div>

        </form>
      </div>
    </mat-tab>

    <!-- Tab: Lista -->
    <mat-tab label="Lista ({{ data.campaign.stats.totalRecipients || 0 }})">
      <div class="p-4 overflow-y-auto max-h-[55vh]">
        
        <!-- Status filters -->
        <div class="flex flex-wrap gap-1 mb-3">
          <button 
            *ngFor="let status of ['pending', 'sent', 'opened', 'error', 'unsubscribed']"
            (click)="onStatusFilter(status)"
            class="px-2 py-1 text-xs rounded-md transition-colors"
            [ngClass]="selectedStatus === status 
              ? 'bg-primary-500 text-white' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'">
            {{ getStatusLabel(status) }} ({{ statusCounts[status] || 0 }})
          </button>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoadingRecipients" class="flex items-center justify-center py-6">
          <mat-spinner diameter="28"></mat-spinner>
        </div>

        <!-- Empty -->
        <div *ngIf="!isLoadingRecipients && recipients.length === 0" class="text-center py-6">
          <mat-icon [svgIcon]="'tabler_outline:inbox'" class="!w-10 !h-10 text-gray-300 mb-2"></mat-icon>
          <p class="text-sm text-gray-500">Brak odbiorców</p>
        </div>

        <!-- Recipients list - compact -->
        <div *ngIf="!isLoadingRecipients && recipients.length > 0" class="space-y-1">
          <div *ngFor="let recipient of recipients" 
               class="px-3 py-2 bg-gray-50 dark:bg-gray-800 rounded-lg text-sm">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2 min-w-0">
                <span class="truncate text-gray-900 dark:text-white">{{ recipient.email }}</span>
                <span *ngIf="recipient.openCount > 0" class="text-xs text-gray-400">({{ recipient.openCount }}x)</span>
              </div>
              <span class="px-2 py-0.5 text-xs font-medium rounded flex-shrink-0" [ngClass]="getStatusClass(recipient.status)">
                {{ getStatusLabel(recipient.status) }}
              </span>
            </div>
            <!-- Error message -->
            <div *ngIf="recipient.status === 'error' && recipient.errorMessage" 
                 class="mt-1 text-xs text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 px-2 py-1 rounded">
              <mat-icon [svgIcon]="'tabler_outline:alert-circle'" class="!w-3 !h-3 inline-block mr-1 align-text-bottom"></mat-icon>
              {{ recipient.errorMessage }}
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <mat-paginator
          *ngIf="recipientsPagination.total > 0"
          [length]="recipientsPagination.total"
          [pageSize]="recipientsPagination.limit"
          [pageIndex]="recipientsPagination.page - 1"
          [pageSizeOptions]="[25, 50, 100]"
          (page)="onPageChange($event)"
          class="mt-3 -mx-4">
        </mat-paginator>

      </div>
    </mat-tab>

  </mat-tab-group>
</div>
